var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('c-header',{attrs:{"navPosition":"right"}}),_c('main',{staticClass:"site-content"},[_vm._t("default")],2),_c('c-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }